<template>
  <div class="PartnerHeader">
    <div :class="{'logos':true, 'em-8-height':(showSAWBOLogo), 'em-5-height':(!showSAWBOLogo)}">
      <div class="partner-logo-cont">
        <a v-if="linkPartnerWebsite" :href="website" target="_blank">
          <!-- <img :src="logo" class="partner-logo" /> -->
          <img
            src="https://sawbo-animations.org/AIDI-CIMMYT/img/CIMMYT_CGIAR_Logo_2024.jpg"
            class="CIMMYT-logo"
          />
        </a>
        <img v-else :src="logo" class="partner-logo" />
      </div>
      <div class="sawbo-logo-cont" v-if="showSAWBOLogo">
        <a href="https://sawbo-animations.org" target="_blank">
          <img
            src="https://sawbo-animations.org/moalfac/img/SAWBO_Logo_500px.jpg"
            class="sawbo-logo"
          />
        </a>
      </div>
    </div>
    <div class="rapid-wordmark">{{ siteTitle }}</div>
    <div v-if="showTranslations" class="rapid-wordmark">
      {{ translatedTitle }}
    </div>
    <nav class="rapid-bar-menu">
      <router-link 
        :class="isActive('videos')" 
        to="/"
      >Videos</router-link>
      <router-link 
        :class="isActive('about')" 
        to="/about"
      >About</router-link>
      <a
        v-if="false"
        :href="website"
        target="_blank"
        class="rapid-bar-menu-link"
        >{{ abbr }} Website</a
      >
      <a
        v-if="showSAWBOLink"
        href="https://sawbo-animations.org"
        target="_blank"
        class="rapid-bar-menu-link"
        >SAWBO Website</a
      >
    </nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PartnerHeader",
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["organization", "siteInfo"]),
    name() {
      return this.organization.name;
    },
    abbr() {
      return this.organization.abbreviation;
    },
    website() {
      return this.organization.website;
    },
    logo() {
      return this.organization.logo;
    },
    siteTitle() {
      return this.siteInfo.title;
    },
    translatedTitle() {
      return this.siteInfo.translatedTitle;
    },
    showSAWBOLogo() {
      return this.siteInfo.showSAWBOLogo;
    },
    showSAWBOLink() {
      return this.siteInfo.showSAWBOLink;
    },
    linkPartnerWebsite() {
      if (this.siteInfo.partnerWebsite.length !== 0) {
        return true;
      } else {
        return false;
      }
    },
    showTranslations() {
      return this.siteInfo.showTranslations;
    },
    hideActiveLink() {
      return this.siteInfo.hideActiveLink;
    }
  },
  methods: {
    isActive(route) {
      let classes = "rapid-bar-menu-link";
      console.log(this.$route.name);
      if(route === this.$route.name) {
        classes += " rapid-bar-menu-link-hide";
      }
      return classes;
    }
  },
};
</script>

<style scoped>

.PartnerHeader {
  width: 100%;
  padding: 2% 0;
}

.logos {
  width: 100%;
  padding: 0 5%;
  border-bottom: 2px solid #fafafa;
}

.em-10-height {
  height: 10em;
}

.em-8-height {
  height: 8em;
}

.em-5-height {
  height: 5em;
}

.partner-logo-cont {
  width: 45%;
  height: 100%;
  float: left;
}

.partner-logo {
  width: 100%;
  max-height: 100%;
  object-fit: contain;
  padding-top:1.5em
}

.sawbo-logo-cont {
  width: 45%;
  height: 100%;
  float: right;
}

.sawbo-logo {
  width: 60%;
  max-height: 100%;
  object-fit: contain;
  vertical-align: middle;
  float: right;
}

.rapid-wordmark {
  width: 100%;
  padding: 0 15%;
  color: #3b5783;
  font-size: 1.6em;
  font-weight: bold;
  text-align: center;
}

.rapid-bar-menu {
  padding: 0.5% 5%;
  background-color: #3b5783;
  color: #ffffff;
  text-align: right;
}

.rapid-bar-menu-link {
  color: #ffffff;
  text-decoration: none;
  padding-left: 15px;
}

.rapid-bar-menu-link:hover {
  text-decoration: underline;
}

.rapid-bar-menu-link-hide {
  display: none !important;
}
.CIMMYT-logo{
   width: 100%;
   padding-top:30px
}
</style>
